var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gb-l-loading gb-l-container"},[_c('animated-guus')],1)}
var staticRenderFns = []

export { render, staticRenderFns }